import axiosInstance from "../../core/axiosConfig.ts";
export default class TranslateService {
    async translateLocation(payload: any) {
        const response = await axiosInstance.post(
            '/admin/translate/location',
            payload
        );
        return response.data;
    }
    async translateItem(payload: any) {
        const response = await axiosInstance.post(
            '/admin/translate/item',
            payload
        );
        return response.data;
    }
    async translateCategory(payload: any) {
        const response = await axiosInstance.post(
            '/admin/translate/category',
            payload
        );
        return response.data;
    }
}